module.exports = __webpack_public_path__ + "vi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vi.svg
// module id = 1137
// module chunks = 0